import { useState } from "react";
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import moment from "moment";

import EventSelects from "components/Charts/Selectors/Events";
import DeviceEventsChart from "components/Charts/DeviceEvents/chart";

// @mui material components
import Grid from "@mui/material/Grid";

function getGroupSize(start, end) {
    var gap = end - start;
    return (gap) / 40;
}

function DeviceEvents({ device, height = "19.125rem" }) {
    const [startTime, setStartTime] = useState(moment().subtract(2, "days"));
    const [endTime, setEndTime] = useState(moment());
    const [advancedToggle, setAdvancedToggle] = useState(false);
    const groupSize = getGroupSize(startTime.unix(), endTime.unix());

    return (
        <SoftBox>
            <EventSelects {...{ startTime, setStartTime, endTime, setEndTime, advancedToggle, setAdvancedToggle }} />
            <DeviceEventsChart  {...{ device, advancedToggle, startTime, setStartTime, endTime, setEndTime, groupSize, height }} />
        </SoftBox>
    );
}

// Typechecking props for the DeviceEvents
DeviceEvents.propTypes = {
    title: PropTypes.string,
    device: PropTypes.object,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DeviceEvents;

